import { action, makeObservable } from 'mobx';

import { SidebarStore } from 'src/app/sidebar/SidebarStore';
import { requireService } from 'src/packages/di';
import { LanguageStore } from 'src/packages/language/LanguageStore';

import { VersionsStore } from '../versions/VersionsStore';

export class RootStore {
  readonly sidebar;
  readonly language;
  readonly versions;

  constructor(readonly auth = requireService('authService'), readonly i18 = requireService('i18')) {
    this.sidebar = new SidebarStore();
    this.language = new LanguageStore(this.i18);
    this.versions = new VersionsStore();

    makeObservable(this);
  }

  @action.bound
  init() {
    this.language.init();
  }
}
